export const DESCRIPTION =
  'Audiences are a group of users who share a set of attributes. Create and save audiences so you can reach the right people at the right time.'
